import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { VerifyEmailPage } from '@/features/auth/pages/VerifyEmailPage';

// The API's confirmation emails link here: `?token=&userId=`.
export const Route = createFileRoute('/verify-email')({
  validateSearch: z.object({
    token: z.string().optional().catch(undefined),
    userId: z.string().optional().catch(undefined),
  }),
  component: VerifyEmailPage,
});
